import type { MarqueeOverlayInfo } from '@viewer/canvas/useInteraction'

// Revit-style colour split:
//   window mode (left→right, contained)   = solid blue
//   crossing mode (right→left, intersect) = dashed green
// Translucent fill on top so the user sees what's behind.
function MarqueeOverlay({ info }: { info: MarqueeOverlayInfo | null }) {
  if (!info || info.width + info.height === 0) return null
  const isWindow = info.mode === 'window'
  return (
    <div
      className="pointer-events-none absolute z-20 border-2"
      style={{
        left: info.x,
        top: info.y,
        width: info.width,
        height: info.height,
        borderStyle: isWindow ? 'solid' : 'dashed',
        borderColor: isWindow ? '#3b82f6' : '#10b981',
        backgroundColor: isWindow
          ? 'rgba(59, 130, 246, 0.12)'
          : 'rgba(16, 185, 129, 0.10)',
      }}
    />
  )
}

export default MarqueeOverlay
